module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Medium.cdcabaf9.woff2";